import { render, staticRenderFns } from "./OrganizationSettings.vue?vue&type=template&id=526be92e&scoped=true&"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js&"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSettings.vue?vue&type=style&index=0&id=526be92e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526be92e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VChip,VCol,VIcon,VRow,VTextField})
